import { render } from "./TelegramAuth.vue?vue&type=template&id=581462fb"
import script from "./TelegramAuth.vue?vue&type=script&lang=js"
export * from "./TelegramAuth.vue?vue&type=script&lang=js"

import "./TelegramAuth.vue?vue&type=style&index=0&id=581462fb&lang=css"

import exportComponent from "/Users/ayarmots/MyDev/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__